module.exports = __webpack_public_path__ + "img/657e10e2c13e2f04304336ad2d48e8fd.png";